<template>
  <div
    class="wrap" 
    v-if="!isLoginPage"
  >
    <common-header/>
    <main class="content">
      <router-view/>
    </main>
  </div>
  <router-view v-else/>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import CommonHeader from '@/components/CommonHeader.vue'
import { autoLogoutIfTokenExpired } from '@/utils/auth'

const route = useRoute();

const isLoginPage = computed(() => {
  return route.name === 'Login'
})

onMounted(() => {
  autoLogoutIfTokenExpired();
});

</script>

<style lang="scss">
#app {
  height: 100%;
}
.wrap {
  height: 100%;
  padding-top: 80px;
}

.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 40px;
  position: relative;
}
</style>
